export function hashValue(val: string | number) {
  let hash = 5381 //djb2
  const valString = val.toString()
  for (let i = 0; i < valString.length; i++) {
    hash = (hash * 33) ^ valString.charCodeAt(i)
  }
  return hash >>> 0
}

/**
 * Hashes an object's json representation - does not work with circular references and does not perform deep sorting.
 * @param object
 * @returns
 */
export function getFastObjectHash(
  object: string | number | Record<string, unknown>,
) {
  if (typeof object !== 'object') {
    return hashValue(object)
  }

  const json = JSON.stringify(object, (_, v) => (v === undefined ? null : v))
  return hashValue(json)
}
